const dict = {
  "nav_group_overview": "Übersicht",
  "nav_group_sales": "Vertrieb",
  "nav_group_customers": "Kunden",
  "nav_group_service": "Service & Qualität",
  "nav_group_contracts": "Verträge",
  "nav_group_operations": "Betrieb",
  "nav_group_purchasing": "Einkauf",
  "nav_sub_suppliers": "Lieferanten",
  "nav_sub_procurement": "Beschaffung",
  "nav_sub_quality": "Qualität",
  "nav_sub_analytics": "Analyse & Einsparungen",
  "nav_sub_governance": "Governance & Systeme",
  "suppliers": "Lieferanten",
  "supplier_contacts": "Lieferanten-Kontakte",
  "supplier_contacts_sub": "Ansprechpartner Ihrer Lieferanten pflegen",
  "confirm_save_title": "Änderungen speichern",
  "confirm_save_changes": "Möchten Sie die Änderungen wirklich speichern?",
  "delete_contact": "Kontakt löschen",
  "confirm_delete_contact": "Möchten Sie diesen Kontakt wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
  "contact_deleted": "Kontakt gelöscht",
  "supplier_documents": "Dokumenten-Fristen",
  "purchase_requisitions": "Bestellanforderungen",
  "purchase_orders": "Bestellungen",
  "invoice_exceptions": "Rechnungs-Ausnahmen",
  "supplier_complaints": "Reklamationen (8D)",
  "supplier_portal_admin": "Lieferantenportal-Zugänge",
  "spend_analytics": "Spend-Analyse",
  "price_variance": "Preisvarianz",
  "scorecards": "Scorecards",
  "consignment": "Konsignation",
  "savings": "Savings-Pipeline",
  "ai_governance": "AI-Governance",
  "erp_monitor": "ERP-Monitor",
  "nav_group_insights": "Analysen",
  "nav_group_ki": "KI",
  "ki_menu": "KI-Menü",
  "ki_costs": "KI-Kosten",
  "quote_comparison": "KI-Angebotsvergleich",
  "line_type": "Positionstyp",
  "product_family": "Produktfamilie",
  "unit": "Einheit",
  "sourcing": "Fertigung",
  "sourcing_internal": "Intern (eigenes Werk)",
  "sourcing_external": "Extern / Fremdfertigung",
  "select_plant": "Werk wählen",
  "subcontractor": "Subunternehmer",
  "subcontractor_cost": "Fremdkosten (intern)",
  "extended_price": "Gesamtpreis",
  "duplicate": "Duplizieren",
  "specifications": "Spezifikationen",
  "pm_flat": "pauschal",
  "no_line_items": "Noch keine Positionen — Produkt- oder Servicezeile hinzufügen.",
  "generate_quote": "Angebot erzeugen",
  "quote_created": "Angebot erstellt",
  "lt_product": "Produkt",
  "lt_artwork": "Druckvorstufe/Artwork",
  "lt_tooling": "Werkzeug/Stanze",
  "lt_storage": "Lagerung (VMI)",
  "lt_freight": "Fracht/Logistik",
  "lt_sample": "Muster/Andruck",
  "lt_other": "Sonstiges",
  "pf_labels": "Rollen-/Haftetiketten",
  "pf_cartons": "Faltschachteln",
  "pf_flexible": "Flexible Verpackung (Beutel/Folie)",
  "pf_other": "Sonstiges",
  "spec_facestock": "Obermaterial / Material",
  "spec_adhesive": "Klebstoff",
  "spec_liner": "Trägermaterial",
  "spec_print_process": "Druckverfahren",
  "spec_finish": "Veredelung (Lack, Folie…)",
  "spec_die_shape": "Stanzform",
  "spec_board_type": "Kartonsorte",
  "spec_caliper": "Grammatur/Dicke",
  "spec_flute": "Welle",
  "spec_coating": "Beschichtung / Kaschierung",
  "spec_die_cut": "Stanzkontur",
  "spec_folding_pattern": "Falt-/Klebemuster",
  "spec_units_per_case": "Einheiten pro Karton",
  "spec_film_structure": "Folienaufbau",
  "spec_pouch_format": "Beutelformat",
  "spec_closure": "Verschlussart",
  "spec_barrier": "Barriereanforderungen",
  "spec_generic": "Spezifikationen",
  "rfq_documents": "Anfragedokumente (RFQ)",
  "rfq_upload": "Hochladen",
  "rfq_paste_email": "E-Mail einfügen",
  "rfq_paste_ph": "RFQ-E-Mail-Text hier einfügen…",
  "rfq_no_docs": "Noch keine RFQ-Dokumente — Datei hochladen oder E-Mail einfügen.",
  "rfq_upload_hint": "PDF, DOCX, XLSX, Bilder (gescannte RFQs), .eml/.msg oder eingefügte E-Mail. Dauerhaft zur Dokumentation gespeichert.",
  "rfq_extract": "Mit KI extrahieren",
  "rfq_extracting": "Extrahiere…",
  "rfq_review_title": "KI-extrahierte Positionen prüfen",
  "rfq_review_desc": "Prüfen und auswählen, bevor die Positionen übernommen werden",
  "rfq_add_selected": "Ausgewählte übernehmen",
  "rfq_none_selected": "Mindestens eine Position auswählen",
  "rfq_added": "Positionen übernommen — prüfen und speichern",
  "rfq_no_extract": "Die KI hat keine Positionen gefunden — bitte manuell erfassen.",
  "rfq_confirm_delete": "Dieses Dokument löschen?",
  "rfq_meta_company": "Firma",
  "rfq_meta_contact": "Ansprechpartner",
  "rfq_meta_delivery": "Gewünschte Lieferung",
  "rfq_meta_target": "Zielpreis / Budget",
  "pipeline_by_family": "Pipeline nach Produktfamilie",
  "external_sourcing_share": "Anteil Fremdfertigung",
  "external_sourcing_help": "Anteil des angebotenen Positionswerts, der extern (fremdgefertigt) produziert wird.",
  "my_access": "Meine Rechte",
  "my_accounts_rights": "Meine Accounts & Rechte",
  "my_role": "Rolle / Profil",
  "visible_accounts": "Sichtbare Accounts",
  "all_accounts_visible": "Sie sehen alle Accounts",
  "active_grants": "Aktive temporäre Berechtigungen",
  "no_grants": "Keine temporären Berechtigungen",
  "access_scope": "Sichtbarkeitsbereich",
  "field_permissions": "Feld-Berechtigungen",
  "roles_rights": "Rollen & Rechte",
  "reassign": "Zuordnen",
  "responsible_reps": "Verantwortliche Vertriebsmitarbeiter",
  "assignment_history": "Zuordnungshistorie",
  "changed_by": "Geändert von",
  "effective_date": "Stichtag",
  "bulk_assign": "Sammelzuordnung",
  "add_grant": "Berechtigung hinzufügen",
  "grant_type": "Typ",
  "deputy": "Vertretung",
  "exception": "Ausnahme",
  "valid_from": "Gültig ab",
  "valid_to": "Gültig bis",
  "reason": "Grund",
  "access_log": "Zugriffsprotokoll",
  "access_deputy": "Zugriff & Vertretung",
  "restricted_account": "Eingeschränkt — nur Basisdaten",
  "restricted_hint": "Sie sind diesem Account nicht zugeordnet. Kaufmännische Daten sind ausgeblendet.",
  "role_profile": "Rollenprofil",
  "account_visibility": "Account-Sichtbarkeit",
  "vis_all": "Alle Accounts",
  "vis_assigned": "Nur zugeordnete",
  "vis_team": "Zugeordnete + Team",
  "unassigned_view": "Nicht zugeordnete Accounts",
  "unassigned_hidden": "Unsichtbar",
  "unassigned_basic": "Nur Basisdaten",
  "see_revenue_qty": "Umsatz / Menge",
  "see_wallet": "Wallet Share & Wettbewerb",
  "see_visit_notes": "Besuchsnotizen",
  "see_web_research": "Externe Recherche",
  "see_ai_analysis": "Account-Analyse (KI)",
  "can_reassign": "Darf Accounts zuordnen",
  "grants_deputy_help": "Temporärer Zugriff auf Accounts eines Kollegen (z.B. Urlaubsvertretung). Läuft automatisch ab.",
  "manager": "Unterstellt (Team Lead)",
  "key_accounts": "Strategische Key Accounts",
  "no_access": "Kein Zugriff",
  "mode_replace": "Ersetzen",
  "mode_add": "Hinzufügen",
  "select_accounts": "Accounts auswählen",
  "user": "Benutzer",
  "dashboard": "Dashboard",
  "accounts": "Kunden",
  "contacts": "Kontakte",
  "leads": "Leads",
  "opportunities": "Verkaufschancen",
  "quotes": "Angebote",
  "complaints": "Reklamationen",
  "admin": "Admin",
  "admin_settings": "Einstellungen",
  "search_placeholder": "Kunden, Kontakte, Chancen suchen…",
  "new": "Neu",
  "logout": "Abmelden",
  "notifications": "Benachrichtigungen",
  "mark_all_read": "Alle gelesen",
  "no_notifications": "Keine Benachrichtigungen",
  "save": "Speichern",
  "cancel": "Abbrechen",
  "delete": "Löschen",
  "edit": "Bearbeiten",
  "create": "Erstellen",
  "close": "Schließen",
  "export_csv": "CSV exportieren",
  "import_csv": "CSV importieren",
  "records": "Einträge",
  "actions": "Aktionen",
  "name": "Name",
  "company": "Firma",
  "account": "Kunde",
  "owner": "Betreuer",
  "status": "Status",
  "stage": "Phase",
  "amount": "Betrag",
  "probability": "Wahrscheinlichkeit",
  "segment": "Segment",
  "segments": "Segmente",
  "add": "Hinzufügen",
  "segments_help": "Segmentliste für Kunden und Werke pflegen. Umbenennen aktualisiert alle zugeordneten Datensätze.",
  "segment_name": "Segmentname",
  "segment_renamed": "Segment umbenannt ✓",
  "segment_deleted": "Segment gelöscht ✓",
  "type": "Typ",
  "email": "E-Mail",
  "phone": "Telefon",
  "mobile": "Mobil",
  "title_field": "Position",
  "department": "Abteilung",
  "buying_role": "Rolle im Buying Center",
  "source": "Quelle",
  "score": "Score",
  "severity": "Schweregrad",
  "defect_category": "Fehlerkategorie",
  "claimed_value": "Reklamationswert",
  "date_received": "Eingangsdatum",
  "sla": "SLA",
  "overdue": "Überfällig",
  "convert": "Konvertieren",
  "converted": "Konvertiert",
  "product_type": "Produkttyp",
  "print_technology": "Drucktechnologie",
  "substrate": "Substrat / Material",
  "finishing": "Veredelung",
  "business_type": "Geschäftsart",
  "competitors": "Wettbewerber",
  "close_reason": "Grund Gewonnen/Verloren",
  "close_date": "Erw. Abschluss",
  "annual_volume": "Jahresvolumen",
  "num_skus": "Anz. SKUs",
  "num_colors": "Anz. Farben",
  "abc_class": "ABC-Klasse",
  "annual_spend": "Jährl. Etikettenbudget",
  "payment_terms": "Zahlungsbedingungen",
  "incoterm": "Incoterm",
  "credit_limit": "Kreditlimit",
  "vat_id": "USt-ID",
  "city": "Stadt",
  "billing_address": "Rechnungsadresse",
  "customer_since": "Kunde seit",
  "certifications": "Zertifizierungen",
  "region": "Region",
  "parent_account": "Muttergesellschaft",
  "kanban": "Kanban",
  "table": "Tabelle",
  "weighted_forecast": "Gewichteter Forecast",
  "aging_alert": "Keine Aktivität seit 14+ Tagen",
  "total_pipeline": "Pipeline gesamt",
  "weighted_pipeline": "Gewichtete Pipeline",
  "win_rate": "Win Rate",
  "avg_deal": "Ø Dealgröße",
  "open_opps": "Offene Chancen",
  "pipeline_by_stage": "Pipeline nach Phase",
  "forecast_by_month": "Forecast nach Monat",
  "forecast_by_rep": "Forecast pro Mitarbeiter",
  "revenue_by_segment": "Umsatz nach Segment",
  "top_opportunities": "Top 10 Verkaufschancen",
  "open_complaints": "Offene Reklamationen",
  "critical": "Kritisch",
  "sla_compliance": "SLA-Einhaltung",
  "avg_resolution": "Ø Lösungsdauer (Tage)",
  "pareto": "Reklamationen nach Kategorie (Pareto)",
  "trend_12m": "Reklamationstrend",
  "by_severity": "Offen nach Schweregrad",
  "top_accounts_complaints": "Top 5 Kunden nach Reklamationswert",
  "revenue_ytd": "Umsatz YTD",
  "vs_py": "vs. Vorjahr",
  "abc_distribution": "Kunden-ABC-Verteilung",
  "churn_risk": "Abwanderungsrisiko",
  "business_split": "Neugeschäft vs. Verlängerung",
  "sales_dash": "Vertrieb",
  "quality_dash": "Qualität",
  "management_dash": "Management",
  "comments": "Kommentare",
  "audit_trail": "Änderungshistorie",
  "add_comment": "Kommentar hinzufügen…",
  "post": "Senden",
  "quote_number": "Angebotsnr.",
  "validity": "Gültig bis",
  "total": "Gesamt",
  "margin": "Marge",
  "version": "Version",
  "revise": "Neue Version",
  "download_pdf": "PDF herunterladen",
  "line_items": "Positionen",
  "material": "Material",
  "width": "Breite",
  "height": "Höhe",
  "quantity": "Menge",
  "unit_price": "Preis/1000",
  "tooling": "Werkzeug",
  "cost": "Kosten/1000",
  "line_total": "Positionssumme",
  "add_line": "Position hinzufügen",
  "price_breaks": "Staffelpreise",
  "winding": "Wicklung",
  "core_size": "Kern",
  "labels_per_roll": "Etiketten/Rolle",
  "d8_report": "8D-Report",
  "claimed_qty": "Reklamierte Menge",
  "accepted_value": "Anerkannter Wert",
  "credit_note": "Gutschriftsnr.",
  "order_number": "Auftragsnr.",
  "article_number": "Artikelnr.",
  "received_via": "Eingang über",
  "costs": "Reklamationskosten",
  "cost_credit": "Gutschrift",
  "cost_reprint": "Nachdruck",
  "cost_freight": "Fracht",
  "save_costs": "Kosten speichern",
  "complaint_new_subtitle": "SLA-Frist und 8D-Report werden automatisch angelegt.",
  "delete_file_confirm": "Diese Datei wirklich löschen?",
  "contact": "Kontakt",
  "new_contact": "Neuer Kontakt",
  "pl_help": "Jede Option hat eine stabile ID (für Auswertungen unveränderlich) und pro Sprache ein Anzeige-Label. Leeres Label fällt auf EN bzw. die ID zurück. Neue Optionen bekommen eine frei wählbare ID (Slug).",
  "pl_new_label": "Neue Option (Label)",
  "pl_id_exists": "Diese ID existiert bereits",
  "users": "Benutzer",
  "picklists": "Auswahllisten",
  "role": "Rolle",
  "territory": "Gebiet",
  "password": "Passwort",
  "add_user": "Benutzer anlegen",
  "tags": "Tags",
  "info": "Details",
  "hierarchy": "Hierarchie",
  "children_accounts": "Tochtergesellschaften",
  "open_opp_value": "Offener Chancenwert",
  "avg_margin": "Ø Marge",
  "estimated_volume": "Gesch. Jahresvolumen",
  "product_interest": "Produktinteresse",
  "possible_duplicate": "Mögliches Duplikat gefunden",
  "login_title": "Bei Encasa anmelden",
  "login_sub": "CRM & SRM für Verpackungshersteller",
  "recently_viewed": "Zuletzt angesehen",
  "no_results": "Keine Treffer",
  "loading": "Lädt…",
  "empty_title": "Noch nichts hier",
  "empty_cta": "Legen Sie den ersten Eintrag an",
  "all_stages": "Alle Phasen",
  "all": "Alle",
  "required_close_reason": "Grund für den Abschluss wählen",
  "mark_won": "Gewonnen",
  "mark_lost": "Verloren",
  "quality": "Qualität",
  "engagement": "Engagement (0-30)",
  "linkedin": "LinkedIn",
  "preferred_language": "Bevorzugte Sprache",
  "birthday": "Geburtstag",
  "notes": "Notizen",
  "shipping_addresses": "Lieferadressen",
  "trade_fair": "Messe",
  "activities": "Aktivitäten",
  "calendar": "Kalender",
  "list_view": "Liste",
  "due_date": "Fällig am",
  "priority": "Priorität",
  "subject": "Betreff",
  "date": "Datum",
  "time": "Uhrzeit",
  "activity_type": "Typ",
  "done": "Erledigt",
  "open_status": "Offen",
  "visit_report": "Besuchsbericht",
  "attendees": "Teilnehmer",
  "topics": "Themen",
  "agreements": "Vereinbarungen",
  "next_steps": "Nächste Schritte",
  "description": "Beschreibung",
  "tradefair": "Messe-Modus",
  "quick_capture": "Schnelle Lead-Erfassung",
  "captured_leads": "Leads erfasst",
  "save_next": "Speichern & nächster Lead",
  "today": "Heute",
  "my_only": "Nur meine",
  "all_team": "Ganzes Team",
  "mark_done": "Erledigt markieren",
  "lead_saved": "Lead gespeichert",
  "samples": "Muster & Artwork",
  "samples_tab": "Musteraufträge",
  "artworks": "Artwork-Freigaben",
  "sample_number": "Musternr.",
  "artwork_number": "Artworknr.",
  "requested_date": "Angefragt am",
  "tracking_number": "Sendungsnr.",
  "upload_pdf": "PDF hochladen",
  "view_pdf": "PDF ansehen",
  "no_file": "Noch keine Datei",
  "contracts": "Verträge",
  "contract_number": "Vertragsnr.",
  "start_date": "Beginn",
  "end_date": "Ende",
  "annual_value": "Jahreswert",
  "price_index": "Preisindex",
  "index_base_value": "Index-Basiswert",
  "indexation_threshold": "Index-Schwellwert %",
  "indexation_clause": "Indexklausel",
  "days_to_expiry": "Tage bis Ablauf",
  "expiring_soon": "Läuft bald ab",
  "expired": "Abgelaufen",
  "forecast": "Forecast & Ziele",
  "target": "Ziel",
  "actual": "Ist",
  "attainment": "Zielerreichung",
  "burndown": "Ziel vs. Ist (kumuliert)",
  "monthly_comparison": "Monatlich Ziel vs. Ist",
  "edit_targets": "Ziele bearbeiten",
  "all_reps": "Alle Mitarbeiter",
  "by_territory": "Nach Gebiet",
  "site_match": "Standort-Matching",
  "suggest_site": "Produktionsstandort vorschlagen",
  "best_press": "Beste Maschine",
  "match_missing": "Nicht abgedeckt",
  "plants": "Werke & Maschinen",
  "presses": "Druckmaschinen",
  "technology": "Technologie",
  "max_colors": "Max. Farben",
  "web_width": "Bahnbreite (mm)",
  "add_plant": "Werk anlegen",
  "add_press": "Maschine hinzufügen",
  "location": "Standort",
  "send_email": "Per E-Mail senden",
  "send_8d": "8D-Report senden",
  "download_8d": "8D-Report PDF",
  "recipient": "Empfänger",
  "message": "Nachricht",
  "send": "Senden",
  "email_sent_ok": "E-Mail gesendet",
  "email_simulated": "E-Mail simuliert (SMTP nicht konfiguriert)",
  "photos": "Fotos & Dateien",
  "upload_photo": "Datei hochladen",
  "portal_users": "Portal-Zugänge",
  "add_portal_user": "Portal-Zugang anlegen",
  "reports": "Reports",
  "report_name": "Report-Name",
  "run_report": "Ausführen",
  "save_report": "Report speichern",
  "shared": "Mit Team geteilt",
  "add_filter": "Filter hinzufügen",
  "field": "Feld",
  "operator": "Operator",
  "value": "Wert",
  "export_excel": "Excel exportieren",
  "my_reports": "Gespeicherte Reports",
  "columns": "Spalten",
  "locations": "Standorte",
  "site_type": "Standorttyp",
  "country": "Land",
  "map_view": "Karte",
  "erp_number": "Lokale ERP-Nr.",
  "timezone": "Zeitzone",
  "lat": "Breitengrad",
  "lng": "Längengrad",
  "account_manager": "Kundenbetreuer",
  "network": "Netzwerk",
  "relationships": "Beziehungen",
  "add_relationship": "Beziehung hinzufügen",
  "relationship_type": "Beziehungstyp",
  "volume_pct": "% des Volumens",
  "contract_ref": "Vertragsreferenz",
  "performance": "Performance",
  "otif": "OTIF",
  "on_time": "Termintreue",
  "in_full": "Mengentreue",
  "fill_rate": "Fill Rate",
  "lead_time": "Lieferzeit-Treue",
  "complaint_rate": "Reklamationen / 1000 Aufträge",
  "forecast_accuracy": "Forecast-Genauigkeit",
  "share_of_wallet": "Share of Wallet",
  "dso": "DSO (Tage)",
  "health_score": "Health",
  "days_late": "Tage Verspätung",
  "scorecard": "Kunden-Scorecard",
  "export_pdf": "PDF exportieren",
  "duplicates": "Dubletten",
  "merge": "Zusammenführen",
  "link_as_network": "Als Netzwerk verknüpfen",
  "confidence": "Konfidenz",
  "pick_survivor": "Überlebenden Datensatz wählen",
  "merged_ok": "Datensätze zusammengeführt",
  "user_location_matrix": "User-Standort-Matrix",
  "weekly_digest": "Wochen-Digest",
  "send_test": "Test senden an…",
  "send_now": "Jetzt an alle Vertriebler senden",
  "digest_enabled": "Automatischer Versand montags 07:00",
  "preview": "Vorschau",
  "perm_groups": "Rechtegruppen",
  "add_group": "Gruppe anlegen",
  "module_rights": "Modulrechte",
  "default_right": "Standardrecht",
  "margins_visible": "Margen sichtbar",
  "scoped_label": "Standortbasierte Sichtbarkeit",
  "orders_12m": "Aufträge (12M)",
  "no_kpi_data": "Noch keine Auftragshistorie für diesen Kunden",
  "qbr_package": "QBR-Paket (PDF)",
  "current_indexes": "Aktuelle Indexwerte",
  "index_deviation": "Δ Index",
  "index_alerts": "Index-Alarme ausgelöst",
  "renew": "Verlängern",
  "renew_contract": "Vertrag verlängern",
  "renewed_from": "Verlängerung aus",
  "duration_months": "Laufzeit (Monate)",
  "new_start_date": "Neuer Beginn",
  "new_end_date": "Neues Ende",
  "contract_renewed": "Vertrag verlängert",
  "import_indexes": "Indexwerte importieren",
  "import_index_help": "CSV einfügen oder Datei hochladen. Formate: lang (date, index_name, value) oder breit (date, Index-A, Index-B, …). Trennzeichen und Datumsformat werden automatisch erkannt (ISO / DE / Monat).",
  "paste_csv": "CSV-Daten einfügen",
  "upload_file": "Datei hochladen",
  "or_upload": "oder Datei hochladen",
  "target_index": "Ziel-Index (nur für Dateien mit einer Wertespalte)",
  "any_column": "Automatisch",
  "import_result": "Importiert",
  "rows_skipped": "übersprungen",
  "index_history": "Indexverlauf",
  "index_trend": "Preisindex-Trend",
  "no_history_yet": "Noch kein Verlauf – Werte bearbeiten oder importieren",
  "last_12m": "12 Monate",
  "last_24m": "24 Monate",
  "last_36m": "36 Monate",
  "manual": "Manuelle Eingabe",
  "import": "Import",
  "guide": "Anleitung",
  "guide_title": "Encasa CRM & SRM Anleitung",
  "guide_subtitle": "Alles, um das Beste aus Ihrer CRM- & SRM-Plattform herauszuholen — Modul für Modul.",
  "guide_intro": "Wählen Sie unten ein Modul, um mehr zu erfahren, oder starten Sie die geführte Tour erneut.",
  "start_tour": "Tour starten",
  "restart_tour": "Geführte Tour erneut abspielen",
  "tour_skip": "Tour überspringen",
  "tour_next": "Weiter",
  "tour_back": "Zurück",
  "tour_finish": "Fertig",
  "tour_step": "Schritt",
  "greeting_morning": "Guten Morgen",
  "greeting_afternoon": "Guten Tag",
  "greeting_evening": "Guten Abend",
  "todays_overview": "Hier ist Ihr Geschäft heute auf einen Blick.",
  "tour_welcome_title": "Willkommen bei Encasa CRM & SRM",
  "tour_welcome_body": "Machen Sie eine kurze 60-Sekunden-Tour durch die wichtigsten Bereiche. Sie können sie jederzeit über die Anleitung-Seite wiederholen.",
  "tour_nav_title": "Hauptnavigation",
  "tour_nav_body": "Springen Sie zwischen allen Modulen — Kunden, Verkaufschancen, Angebote, Reklamationen, Verträge und mehr.",
  "tour_search_title": "Globale Suche",
  "tour_search_body": "Finden Sie Kunden, Kontakte, Chancen, Angebote und Reklamationen sofort von überall.",
  "tour_new_title": "Schnell Datensätze anlegen",
  "tour_new_body": "Über den Neu-Button legen Sie jeden Datensatztyp an, ohne die aktuelle Seite zu verlassen.",
  "tour_notif_title": "Benachrichtigungen",
  "tour_notif_body": "SLA-Verstöße, auslaufende Verträge und Freigabe-Erinnerungen landen alle hier.",
  "tour_done_title": "Alles startklar!",
  "tour_done_body": "Öffnen Sie jederzeit die Anleitung-Seite für ausführliche Hilfe zu jedem Modul.",
  "guide_desc_dashboard": "Vertriebs-, Qualitäts- und Management-Dashboards mit Live-KPIs, Pipeline, Forecasts und Abwanderungsrisiko.",
  "guide_desc_accounts": "360°-Kundensicht: Hierarchie, Zertifizierungen, KPIs, Netzwerkbeziehungen und QBR-Export.",
  "guide_desc_locations": "Verwalten Sie Werks-/Standorte mit Kartenansicht sowie Region- und Standorttyp-Filter.",
  "guide_desc_contacts": "Kontakte mit Mehrfach-Kundenverknüpfungen und Buying-Center-Rollen.",
  "guide_desc_leads": "Lead-Scoring und Ein-Klick-Konvertierung zu Kunde, Kontakt und Verkaufschance.",
  "guide_desc_opportunities": "Drag-&-Drop-Kanban-Pipeline, gewichteter Forecast, Aging-Alarme und Standort-Matching.",
  "guide_desc_quotes": "Positionsbasierte Angebote mit Preisstaffeln, Margen, Versionierung und PDF-Export.",
  "guide_desc_complaints": "8D-Reklamationsmanagement mit SLA-Tracking, Eskalation und Kostenerfassung.",
  "guide_desc_samples": "Musteraufträge und Artwork-Freigaben mit echtem PDF-Upload und Status-Workflow.",
  "guide_desc_contracts": "Verträge mit Preisindex-Klauseln, Verlängerungs-Workflow und Trend-Charts.",
  "guide_desc_activities": "Anrufe, Meetings, Besuche und Aufgaben mit gemeinsamem Team-Kalender.",
  "guide_desc_reports": "Individueller Report-Builder mit Filtern, gespeicherten Berichten und Excel-Export.",
  "guide_desc_forecast": "Gebietsziele vs. Ist-Werte mit Zielerreichungs-KPIs und Burndown-Charts.",
  "guide_desc_tradefair": "Mobil-optimierte schnelle Lead-Erfassung für Messen.",
  "guide_desc_admin": "Benutzer, Rechtegruppen, Auswahllisten, Werke, Dubletten und Digest-Einstellungen.",
  "customer_forecast": "Kunden-Forecast",
  "select_account": "Kunde auswählen",
  "fiscal_year": "Geschäftsjahr",
  "scope": "Ebene",
  "customer_level": "Kundenebene (kein Projekt)",
  "all_projects": "Alle (aggregiert)",
  "projects": "Projekte",
  "project": "Projekt",
  "new_project": "Neues Projekt",
  "add_project": "Projekt anlegen",
  "project_name": "Projektname",
  "link_opportunity": "Verkaufschance verknüpfen (optional)",
  "no_opp_link": "Keine Verkaufschance",
  "delete_project": "Projekt löschen",
  "project_deleted": "Projekt gelöscht",
  "project_created": "Projekt angelegt",
  "metric": "Kennzahl",
  "revenue": "Umsatz",
  "month": "Monat",
  "fc_revenue": "Forecast Umsatz",
  "actual_revenue": "Ist Umsatz",
  "fc_qty": "Forecast Menge",
  "actual_qty": "Ist Menge",
  "total_forecast": "Forecast gesamt",
  "total_actual": "Ist gesamt",
  "deviation": "Abweichung",
  "save_forecast": "Speichern",
  "forecast_saved": "Forecast gespeichert",
  "forecast_vs_actual": "Forecast vs. Ist",
  "import_excel": "Excel importieren",
  "download_template": "Vorlage",
  "import_done": "Zeilen importiert",
  "aggregate_readonly": "Aggregierte Ansicht ist schreibgeschützt — Projekt oder Kundenebene zum Bearbeiten wählen.",
  "guide_desc_customer_forecast": "Monatlicher Kunden- & Projekt-Forecast vs. Ist (Umsatz + Menge) mit Excel Up-/Download.",
  "autofill_actuals": "Ist aus Aufträgen ziehen",
  "autofilled": "Ist-Monate befüllt",
  "no_autofill": "Keine neuen Ist-Werte gefunden",
  "group": "Gruppe",
  "group_rollup": "Gruppen-Übersicht",
  "members": "Mitglieder",
  "fillers": "Abfüller / Co-Packer",
  "global_cs": "Global Customer Service",
  "assign_global_cs": "Globalen CS-Verantwortlichen zuweisen",
  "cs_assigned": "Globaler CS-Verantwortlicher gesetzt",
  "group_complaints": "Reklamationen der Gruppe",
  "total_members": "Mitglieder",
  "no_cs_owner": "Nicht zugewiesen",
  "open_pipeline": "Offene Pipeline",
  "top_customer_forecast": "Top-Kunden · Forecast vs. Ist",
  "portal_quotes": "Angebote",
  "portal_artworks": "Artwork-Freigaben",
  "approve": "Freigeben",
  "reject": "Überarbeitung anfordern",
  "decision_saved": "Entscheidung gespeichert",
  "add_note": "Anmerkung (optional)",
  "awaiting_decision": "Wartet auf Ihre Entscheidung",
  "no_quotes_portal": "Noch keine Angebote verfügbar.",
  "no_artworks_portal": "Keine Artworks zur Prüfung.",
  "forecast_approvals": "Forecast-Freigaben",
  "approval_status": "Freigabe",
  "submit_for_approval": "Zur Freigabe einreichen",
  "fc_approve": "Freigeben",
  "fc_reject": "Ablehnen",
  "reject_reason": "Ablehnungsgrund",
  "st_draft": "Entwurf",
  "st_submitted": "In Freigabe",
  "st_approved": "Freigegeben",
  "st_rejected": "Abgelehnt",
  "st_none": "Nicht eingereicht",
  "no_pending_approvals": "Keine Forecasts zur Freigabe.",
  "submitted_by": "Eingereicht von",
  "pending_approval_hint": "In Freigabe (noch nicht als verbindlich gezählt)",
  "approved_fc": "Freigegeben",
  "pending_fc": "In Freigabe",
  "group_qbr": "Gruppen-QBR (PDF)",
  "submitted_ok": "Zur Freigabe eingereicht",
  "approved_ok": "Forecast freigegeben",
  "rejected_ok": "Forecast abgelehnt",
  "guide_desc_forecast_approvals": "Vom Vertrieb eingereichte Kunden-Forecasts prüfen, freigeben oder ablehnen.",
  "history": "Verlauf",
  "show_history": "Verlauf",
  "no_history": "Noch kein Verlauf.",
  "ev_submitted": "eingereicht",
  "ev_approved": "freigegeben",
  "ev_rejected": "abgelehnt",
  "send_reminders": "Erinnerungen jetzt senden",
  "reminders_sent_msg": "Erinnerungen gesendet",
  "lp_switch_normal": "Normal",
  "lp_switch_hero": "Hero-Mode",
  "lp_eyebrow": "CRM & SRM für Verpackungshersteller",
  "lp_title": "Vertrieb und Einkauf auf einer Plattform.",
  "lp_desc": "Kunden, Pipeline, Angebote und Qualität — plus Lieferantenmanagement, Bank-4-Augen-Verifizierung und Beschaffung. Eine Plattform für Verpackungshersteller: Etiketten, Shrink Sleeves, flexible Verpackungen und Faltschachteln.",
  "lp_cta": "Bei Encasa anmelden",
  "lp_f1_t": "Vertrieb & Angebote",
  "lp_f1_d": "Pipeline verfolgen, PDF-Angebote erstellen und Umsatz prognostizieren.",
  "lp_f2_t": "Einkauf & Lieferanten",
  "lp_f2_d": "Lieferantenstammdaten, Bank-4-Augen-Prinzip und Beschaffung.",
  "lp_f3_t": "Qualität & KPIs",
  "lp_f3_d": "8D-Reklamationen, Scorecards, Forecasts und QBR-Reports.",
  "lp_nav_signin": "Anmelden",
  "lp_features_title": "Alles für Vertrieb und Einkauf",
  "lp_features_sub": "Eine Plattform für den gesamten kaufmännischen Zyklus — vom Lead bis zur Lieferung, vom Lieferanten bis zur Rechnung.",
  "lp_f4_t": "Verträge & KI",
  "lp_f4_d": "KI-Vertragsauslese, Fristenmanagement und Preisindex-Klauseln.",
  "lp_f5_t": "Analytics & Forecasts",
  "lp_f5_d": "Live-Dashboards, Kunden-Forecasts und Management-KPIs.",
  "lp_f6_t": "Portale & Zusammenarbeit",
  "lp_f6_d": "Kunden- und Lieferantenportale mit sicherem, auditiertem Zugriff.",
  "lp_signin_card_title": "Willkommen zurück",
  "lp_explore": "Funktionen entdecken",
  "lp_stat1_l": "Kundensicht 360°",
  "lp_stat2_l": "Sprachen",
  "lp_stat3_l": "Qualitätsprozess",
  "lp_stat4_l": "Lieferantenmanagement",
  "hero_eyebrow": "Das außergewöhnliche CRM-Team",
  "hero_tagline": "Rette deine Pipeline. Besiege das Chaos.",
  "hero_desc": "Sieben Helden. Eine Mission: Churn zerschlagen, SLAs pulverisieren und jeden Deal in letzter Sekunde retten.",
  "hero_cta": "Werde Teil der Force",
  "hero_p1_t": "Pipeline-Kraftpaket",
  "hero_p1_d": "Rase mit übermenschlichem Tempo durch deinen Sales-Funnel.",
  "hero_p2_t": "Reklamations-Bezwinger",
  "hero_p2_d": "Neutralisiere Qualitätsgefahren, bevor sie eskalieren.",
  "hero_p3_t": "Forecast-Blick",
  "hero_p3_d": "Sieh die Umsatz-Zukunft jedes Kunden voraus.",
  "hero_meet": "Das Team",
  "visit_notes": "Besuchsnotizen",
  "vn_record": "Notiz aufnehmen",
  "vn_recording": "Nimmt auf…",
  "vn_stop": "Aufnahme stoppen",
  "vn_transcribing": "Transkribiere…",
  "vn_analyzing": "KI analysiert…",
  "vn_transcript": "Transkript",
  "vn_edit_transcript": "Transkript vor dem Speichern prüfen & bearbeiten (Diktat von Produktnamen ist fehleranfällig).",
  "vn_analyze_save": "Analysieren & speichern",
  "vn_ai_summarize": "Mit KI zusammenfassen",
  "vn_ai_summary_title": "KI-Zusammenfassung (Besuchsbericht-Assistent)",
  "vn_ai_apply": "Übernehmen",
  "vn_language": "Sprache",
  "vn_auto": "Automatisch erkennen",
  "vn_manual_entry": "Manuell eingeben",
  "vn_upload_email": "E-Mail hochladen",
  "vn_manual_text_ph": "Besuchsnotiz hier eintippen…",
  "vn_source": "Quelle",
  "vn_source_voice": "Diktat",
  "vn_source_email": "E-Mail",
  "vn_source_manual": "Manuell",
  "vn_risk": "Einstufung",
  "vn_risk_green": "Normal",
  "vn_risk_yellow": "Beobachten",
  "vn_risk_orange": "Risiko",
  "vn_risk_red": "Eskalation",
  "vn_partner": "Gesprächspartner & Rolle",
  "vn_topics": "Besprochene Themen",
  "vn_agreements": "Zusagen / offene Punkte",
  "vn_competitors": "Genannte Wettbewerber",
  "vn_pricing": "Preis- / Konditionenthemen",
  "vn_next_steps": "Nächste Schritte",
  "vn_triggers": "Trigger-Themen",
  "vn_reason": "Begründung",
  "vn_override": "Einstufung korrigieren",
  "vn_override_reason": "Grund für die Korrektur (Pflicht)",
  "vn_linked_opps": "Verknüpfte Verkaufschancen",
  "vn_suggested_tasks": "Vorgeschlagene Aufgaben",
  "vn_create_tasks": "Ausgewählte Aufgaben anlegen",
  "vn_tasks_created": "Aufgaben angelegt",
  "vn_assignee": "Verantwortlich",
  "vn_no_notes": "Noch keine Besuchsnotizen.",
  "vn_filter_all_sources": "Alle Quellen",
  "vn_filter_all_risks": "Alle Einstufungen",
  "vn_search_ph": "Notizen durchsuchen… (z.B. wann war Preis zuletzt Thema)",
  "vn_from": "Von",
  "vn_to": "Bis",
  "vn_creator": "Ersteller",
  "vn_all_creators": "Alle Ersteller",
  "vn_saved": "Notiz gespeichert",
  "vn_show_transcript": "Transkript anzeigen",
  "vn_hide_transcript": "Transkript ausblenden",
  "vn_mic_error": "Mikrofon nicht verfügbar. Bitte manuelle Eingabe oder E-Mail-Upload nutzen.",
  "vn_reanalyze": "Neu analysieren",
  "vn_corrected": "korrigiert",
  "vn_new_note": "Neue Notiz",
  "vn_who": "Wer",
  "vn_what": "Was",
  "vn_due": "Bis wann",
  "vn_record_hint": "Direkt nach dem Termin antippen und diktieren.",
  "vn_task_subject": "Aufgabe",
  "vn_add_task": "Aufgabe hinzufügen",
  "escalation": "Eskalation",
  "escalation_help": "Wer bei Rot-Einstufungen benachrichtigt wird und den wöchentlichen Risiko-Digest erhält.",
  "escalation_saved": "Empfänger gespeichert",
  "sla_rules": "SLA-Regeln",
  "sso_tab": "Microsoft SSO",
  "sso_signin": "Mit Microsoft anmelden",
  "sso_help": "Single Sign-On über Microsoft Entra ID (Azure AD). Nur bereits im CRM angelegte Benutzer können sich per Microsoft anmelden (Abgleich per E-Mail).",
  "sso_enabled": "Microsoft-Anmeldung aktivieren",
  "sso_tenant": "Directory (Tenant) ID",
  "sso_client_id": "Application (Client) ID",
  "sso_secret": "Client Secret",
  "sso_secret_ph": "Neues Secret eingeben (leer lassen, um vorhandenes zu behalten)",
  "sso_domains": "Erlaubte E-Mail-Domains",
  "sso_domains_help": "Kommagetrennt, z. B. ihrefirma.de, tochter.de. Leer = keine Domain-Beschränkung.",
  "sso_callback": "Redirect-URI (in Azure registrieren)",
  "sso_callback_help": "Fügen Sie genau diese URI in Ihrer Azure App-Registrierung unter Authentifizierung → Web hinzu.",
  "sso_saved": "SSO-Einstellungen gespeichert",
  "sla_saved": "SLA-Regeln gespeichert",
  "saving": "Speichern…",
  "hours": "Stunden",
  "days": "Tage",
  "sla_help": "Konfigurieren Sie die SLA-Schwellwerte, die automatische Erinnerungen und Eskalationen im CRM steuern.",
  "sla_complaint_ack_hours": "Reklamations-Bestätigung",
  "sla_complaint_ack_hours_desc": "Stunden, bis eine neue Reklamation an das Management eskaliert wird, wenn sie nicht bestätigt wird.",
  "sla_artwork_reminder_days": "Druckvorlagen-Freigabe-Erinnerung",
  "sla_artwork_reminder_days_desc": "Tage, die eine gesendete Druckvorlage auf Kundenfreigabe warten darf, bevor der Verantwortliche erinnert wird.",
  "sla_contract_renewal_days": "Vertragsverlängerungs-Fenster",
  "sla_contract_renewal_days_desc": "Tage vor Vertragsende, ab denen Verlängerungserinnerungen starten.",
  "orgchart_tab": "Org-Chart",
  "orgchart_title": "Buying-Center-Karte",
  "orgchart_subtitle": "Kontakte nach Entscheidungs-Einfluss angeordnet.",
  "orgchart_tier_decision": "Entscheidung",
  "orgchart_tier_influence": "Einfluss & Fürsprache",
  "orgchart_tier_operational": "Operativ / Zugang",
  "orgchart_tier_empty": "Keine Kontakte in dieser Ebene",
  "orgchart_no_role": "Ohne Rolle",
  "orgchart_empty": "Noch keine Kontakte — legen Sie Kontakte an, um die Buying-Center-Karte zu sehen.",
  "orgchart_show_all": "Alle anzeigen",
  "role_decision_maker": "Decision Maker",
  "role_champion": "Champion",
  "role_influencer": "Influencer",
  "role_gatekeeper": "Gatekeeper",
  "role_user": "User",
  "guide_desc_visit_notes": "KI-Besuchsnotizen: diktieren oder E-Mails hochladen, strukturierte Zusammenfassung und 4-stufige Risikoeinstufung.",
  "ai_contract_analysis": "KI-Vertragsauslese",
  "contract_summary": "Zusammenfassung",
  "contract_deviations": "Abweichungen zu CRM-Daten",
  "no_deviations": "Keine Abweichungen erkannt.",
  "contract_value": "Vertragswert",
  "crm_value": "CRM-Wert",
  "deviation_match": "Übereinstimmung",
  "deviation_deviation": "Abweichung",
  "deviation_unknown": "Unklar",
  "severity_critical": "Kritisch",
  "severity_warning": "Warnung",
  "severity_info": "Info",
  "extracted_terms": "Extrahierte Vertragsdaten",
  "contract_parties": "Vertragsparteien",
  "contract_term": "Laufzeit",
  "notice_period": "Kündigungsfrist",
  "auto_renewal": "Automatische Verlängerung",
  "pricing_conditions": "Preise & Konditionen",
  "volume_minimum": "Volumen / Mindestabnahme",
  "liability_warranty": "Haftung & Gewährleistung",
  "price_index_clauses": "Preisindex-Klauseln",
  "upload_contract_doc": "Vertrag hochladen (PDF/DOCX)",
  "analyzing": "Analysiere…",
  "analyzing_hint": "Die Vertragsdaten werden per KI ausgelesen — das kann bis zu 30 Sekunden dauern.",
  "only_pdf_docx": "Nur PDF oder DOCX",
  "no_contract_docs": "Noch keine Vertragsdokumente hochgeladen.",
  "deviations_short": "Abweichungen",
  "ok": "OK",
  "pages": "Seiten",
  "paragraphs": "Absätze",
  "ref_page": "S.",
  "ref_paragraph": "Abs.",
  "months": "Monate",
  "yes": "Ja",
  "no": "Nein",
  "extraction_done": "KI-Auslese abgeschlossen",
  "extraction_failed": "KI-Auslese fehlgeschlagen",
  "confirm_delete_doc": "Dieses Dokument löschen?",
  "deleted": "Gelöscht",
  "view_original": "Original ansehen",
  "reextract": "Neu auslesen",
  "back": "Zurück",
  "contract_deadlines": "Vertragsfristen",
  "contract_deadlines_subtitle": "Kündigungsfristen, Verlängerungen und Ablauf — auf Basis der KI-ausgelesenen Vertragsdaten.",
  "refresh": "Aktualisieren",
  "urgency": "Dringlichkeit",
  "urgency_notice_missed": "Frist verpasst",
  "urgency_notice_soon": "Kündigungsfrist bald",
  "urgency_expired": "Abgelaufen",
  "urgency_expiring_soon": "Läuft bald ab",
  "urgency_none": "OK",
  "notice_deadline": "Kündigungstermin",
  "with_ai_analysis": "Mit KI-Auslese",
  "no_deadlines": "Keine offenen Verträge.",
  "no_notice_detected": "Keine Kündigungsfrist erkannt",
  "upload_for_notice": "Vertrag hochladen",
  "contract_data": "Vertragsdaten",
  "documents": "Dokumente",
  "account_analysis": "Account-Analyse",
  "ai_analysis": "KI-Account-Analyse",
  "wallet_share_tab": "Werk & Wallet-Share",
  "last_generated": "Zuletzt generiert",
  "generate_now": "Jetzt generieren",
  "update_now": "Jetzt aktualisieren",
  "ai_never_run": "Noch keine Analyse generiert.",
  "generating": "Analyse wird erstellt…",
  "ai_trend": "Trendentwicklung",
  "ai_sentiment": "Stimmungsverlauf",
  "ai_stakeholders": "Stakeholder-Machtanalyse",
  "ai_wallet": "Wallet-Share-Entwicklung",
  "ai_risks_opps": "Risikofaktoren & Chancen",
  "ai_recommendations": "Handlungsempfehlung",
  "ai_direction": "Richtung",
  "dir_growing": "wachsend",
  "dir_stable": "stabil",
  "dir_declining": "rückläufig",
  "ai_notable_jumps": "Auffällige Sprünge",
  "ai_no_data": "Für diesen Baustein liegen noch keine Daten vor.",
  "ai_role": "Rolle / Einfluss",
  "ai_stance": "Haltung uns gegenüber",
  "ai_flag": "Veränderungs-Flag",
  "risk_label": "Risiko",
  "chance_label": "Chance",
  "priority_short": "Prio",
  "ext_research": "Externe Recherche",
  "ext_research_sub": "Öffentliche Quellen · unverifiziert",
  "ext_update": "Recherche aktualisieren",
  "ext_never": "Noch keine externe Recherche.",
  "ext_researching": "Öffentliche Quellen werden recherchiert…",
  "ext_news": "Firmennews",
  "ext_financials": "Finanzielle Lage",
  "ext_strategy": "Strategische Ausrichtung",
  "ext_market_comp": "Wettbewerbsumfeld des Kunden",
  "ext_contact_check": "Ansprechpartner-Abgleich",
  "ext_no_info": "Keine relevanten öffentlichen Informationen gefunden.",
  "ext_unverified": "unverifiziert · öffentliche Quelle",
  "ext_source": "Quelle",
  "ext_no_date": "o. Datum",
  "internal_verified": "verifiziert · eigene Aufzeichnung",
  "ws_plant_supply": "Werk → Kunde Belieferung",
  "ws_add_supply": "Belieferung hinzufügen",
  "ws_plant": "Werk",
  "ws_period": "Zeitraum",
  "ws_period_month": "Monatlich",
  "ws_period_quarter": "Quartalsweise",
  "ws_qty": "Menge",
  "ws_unit": "Einheit",
  "ws_revenue": "Umsatz (EUR)",
  "ws_wallet": "Wallet Share (Kundenebene)",
  "ws_add_wallet": "Wallet-Share-Eintrag hinzufügen",
  "ws_category": "Kategorie",
  "ws_budget": "Gesamtbudget/-bedarf (EUR)",
  "ws_our_eur": "Unser Anteil (EUR)",
  "ws_our_pct": "Unser Anteil %",
  "ws_comp_pct": "Wettbewerbsanteil %",
  "ws_total_pct": "Summe %",
  "ws_competitors": "Wettbewerber",
  "ws_comp_name": "Wettbewerber",
  "ws_comp_share": "Anteil %",
  "ws_comp_source": "Quelle",
  "ws_add_competitor": "Wettbewerber hinzufügen",
  "ws_over100": "Summe der Anteile überschreitet 100% — bitte prüfen.",
  "ws_stale": "Wallet-Share-Daten sind älter als 6 Monate — bitte aktualisieren.",
  "ws_trend": "Wallet Share über Zeit",
  "ws_no_supply": "Noch keine Werk-Belieferungen erfasst.",
  "ws_no_wallet": "Noch keine Wallet-Share-Einträge.",
  "ws_notes": "Notizen / Quelle",
  "ws_change_history": "Änderungshistorie",
  "ws_saved": "Gespeichert",
  "ws_deleted": "Gelöscht",
  "plant_view": "Werk-Sicht",
  "plant_view_sub": "Welche Kunden jedes Werk beliefert",
  "pv_customers": "Kunden",
  "pv_total_qty": "Gesamtmenge",
  "pv_total_revenue": "Gesamtumsatz",
  "pv_no_data": "Noch keine Belieferungsdaten für dieses Werk.",
  "pv_select_plant": "Alle Werke",
  "guide_desc_plant_view": "Aggregierte Werk-Sicht: welche Kunden jedes Werk mit welchem Volumen beliefert.",
  "analysis_pdf": "Analyse-PDF (QBR)",
  "access_denied_intel": "Nur Vertrieb, KAM und Management dürfen diese Daten sehen.",
  "language": "Sprache",
  "lang_en": "Englisch",
  "lang_de": "Deutsch",
  "lang_es": "Spanisch",
  "lang_pt": "Portugiesisch",
  "lang_it": "Italienisch",
  "translate": "Übersetzen",
  "translating": "Übersetze…",
  "show_original": "Original anzeigen",
  "translated_hint": "KI-Übersetzung — Fachbegriffe (Wallet Share, OTIF, SLA…) bleiben englisch.",
  "faq": "FAQ",
  "copy": "Kopieren",
  "copied": "Kopiert",
  "outlook_addin": "Outlook Add-in",
  "outlook_addin_title": "Outlook Add-in",
  "outlook_addin_intro": "Installiere das Encasa-CRM-Add-in in Outlook und übernimm jede E-Mail mit einem Klick als Lead, Reklamation oder Aktivität — direkt aus deinem Posteingang.",
  "outlook_addin_manifest": "Add-in-Manifest",
  "outlook_addin_download": "Manifest herunterladen",
  "outlook_addin_s1_t": "Manifest herunterladen",
  "outlook_addin_s1_d": "Lade die Manifest-Datei oben herunter (oder kopiere die URL für eine zentrale Verteilung über deinen Microsoft-365-Administrator).",
  "outlook_addin_s2_t": "In Outlook hinzufügen",
  "outlook_addin_s2_d": "In Outlook im Web ODER im klassischen Outlook 365 Desktop (Windows) bzw. dem neuen Outlook: Menü/Einstellungen → 'Add-Ins abrufen' / 'Add-Ins verwalten' → Meine Add-Ins → 'Benutzerdefiniertes Add-In hinzufügen' → 'Aus Datei hinzufügen' und das heruntergeladene Manifest auswählen. Admins können es im Microsoft-365-Admin-Center für die ganze Organisation ausrollen.",
  "outlook_addin_s3_t": "E-Mail öffnen",
  "outlook_addin_s3_d": "Öffne eine Nachricht und klicke auf die Schaltfläche 'In CRM übernehmen'. Melde dich einmalig mit deinem Encasa-CRM-Konto an (gleiche E-Mail und Passwort).",
  "outlook_addin_s4_t": "Ins CRM übernehmen",
  "outlook_addin_s4_d": "Wähle Lead, Reklamation oder Aktivität. Der Absender wird automatisch einem bestehenden Kunden zugeordnet, und der neue Datensatz öffnet sich im CRM.",
  "outlook_addin_note": "Das Add-in liest ausschließlich die aktuell geöffnete Nachricht (ReadItem-Berechtigung) und sendet sie per HTTPS an Encasa CRM. Es läuft in Outlook im Web, im klassischen Outlook 365 Desktop (Windows) und im neuen Outlook für Windows/Mac — jeweils mit einem Microsoft-365-/Exchange-Konto (nicht mit reinen POP/IMAP-Konten). Für das persönliche Sideloading ist keine Microsoft-Admin-Zustimmung nötig.",
  "faq_title": "Häufige Fragen",
  "faq_subtitle": "Schnelle Antworten auf die häufigsten Fragen zu Encasa CRM & SRM.",
  "faq_intro": "Nichts Passendes gefunden? Starten Sie die geführte Tour erneut oder öffnen Sie oben eine Modul-Anleitung.",
  "guide_faq_card": "FAQ",
  "guide_desc_faq": "Antworten auf häufige Fragen zu Rollen, Verträgen, Forecasts, Sprachen und KI-Funktionen.",
  "guide_getting_started": "Erste Schritte",
  "guide_gs_intro": "Vier kurze Schritte, um vom ersten Tag an produktiv zu sein.",
  "guide_gs_1_t": "1 · Alles schnell finden",
  "guide_gs_1_d": "Nutzen Sie die globale Suche oben, um zu jedem Kunden, Kontakt, jeder Chance, jedem Angebot oder jeder Reklamation zu springen.",
  "guide_gs_2_t": "2 · Ihre Kunden bearbeiten",
  "guide_gs_2_d": "Öffnen Sie einen Kunden für die 360°-Sicht — Hierarchie, KPIs, Verträge, Besuchsnotizen und KI-Analyse an einem Ort.",
  "guide_gs_3_t": "3 · Fristen im Blick behalten",
  "guide_gs_3_d": "Die Benachrichtigungsglocke und die Seite Vertragsfristen zeigen SLA-Verstöße, Verlängerungen und Kündigungsfristen.",
  "guide_gs_4_t": "4 · In Ihrer Sprache arbeiten",
  "guide_gs_4_d": "Wechseln Sie die Oberfläche jederzeit zwischen DE/EN/ES/PT/IT über die Sprachauswahl in der Kopfleiste.",
  "guide_more_help": "Weitere Hilfe nötig?",
  "guide_open_faq": "FAQ öffnen",
  "guide_desc_my_access": "Sehen Sie Ihre Rolle, Feld-Berechtigungen, sichtbare Accounts und aktive Vertretungen.",
  "faq_q1": "Wie funktionieren Rollen und Berechtigungen?",
  "faq_a1": "Jeder Benutzer hat eine Rolle (Admin, Vertriebsleiter, Vertriebsmitarbeiter, Kundenservice, Nur-Lesen) plus optional ein Rechteprofil. Diese bestimmen, welche Kunden Sie sehen, ob kaufmännische Daten (Umsatz, Margen, Wallet Share) sichtbar sind und ob Sie bearbeiten dürfen. Prüfen Sie Ihre Rechte auf der Seite „Meine Rechte“.",
  "faq_q2": "Ich muss einen Account eines Kollegen bearbeiten. Wie erhalte ich Zugriff?",
  "faq_a2": "Ein Admin oder Vertriebsleiter kann Ihnen unter Admin → Zugriff & Vertretung eine temporäre Vertretung (z. B. Urlaubsvertretung) oder eine einmalige Ausnahme gewähren. Berechtigungen haben ein Start-/Enddatum und laufen automatisch ab.",
  "faq_q3": "Wie funktioniert die KI-Vertragsauslese?",
  "faq_a3": "Öffnen Sie einen Vertrag, gehen Sie zum Reiter Dokumente und laden Sie eine PDF oder DOCX hoch. GPT-4o extrahiert Laufzeit, Kündigungsfrist, automatische Verlängerung, Preise und Indexklauseln — jeweils mit Seiten-/Absatzverweis — und markiert Abweichungen zu Ihren CRM-Daten. Ihre Daten werden nie geändert, nur berichtet.",
  "faq_q4": "Was bedeuten die Dringlichkeiten bei Vertragsfristen?",
  "faq_a4": "„Frist verpasst“ = die Kündigungsfrist ist abgelaufen; „Kündigungsfrist bald“ = innerhalb von 30 Tagen; „Läuft bald ab“ = endet innerhalb von 90 Tagen; „Abgelaufen“ = Enddatum überschritten. Sie basieren auf der KI-ausgelesenen Kündigungsfrist — laden Sie das Vertragsdokument hoch, um sie zu aktivieren.",
  "faq_q5": "Wie funktionieren Forecasts und Freigaben?",
  "faq_a5": "Erfassen Sie den monatlichen Forecast vs. Ist pro Kunde und Projekt. Mitarbeiter reichen einen Geschäftsjahres-Forecast zur Freigabe ein; Vertriebsleiter geben ihn in der Warteschlange „Forecast-Freigaben“ frei oder lehnen ihn ab. Freigegebene Forecasts gelten als verbindlich; eine Bearbeitung setzt ihn zur erneuten Freigabe auf Entwurf zurück.",
  "faq_q6": "Welche Sprachen werden unterstützt und wie wechsle ich?",
  "faq_a6": "Die Oberfläche ist in Deutsch, Englisch, Spanisch, Portugiesisch und Italienisch verfügbar. Nutzen Sie die Sprachauswahl in der Kopfleiste — Ihre Wahl wird auf diesem Gerät gespeichert. Fachbegriffe wie Wallet Share, OTIF, SLA und QBR bleiben bewusst englisch.",
  "faq_q7": "Kann ich eine Notiz oder Zusammenfassung in einer anderen Sprache übersetzen?",
  "faq_a7": "Ja. KI-generierte Zusammenfassungen (Vertragsauslese, Account-Analyse, Besuchsnotizen) zeigen einen Link „Übersetzen“, der den Text bei Bedarf in Ihrer aktuellen Oberflächensprache anzeigt und ein Zurückschalten zum Original erlaubt.",
  "faq_q8": "Wie funktionieren Reklamationen, 8D und SLA-Tracking?",
  "faq_a8": "Reklamationen erhalten automatisch eine REK-Nummer und eine Bestätigungs-SLA. Werden sie nicht rechtzeitig bestätigt, eskalieren sie an das Management. Erfassen Sie den 8D-Report (D1–D8) und die Kosten und senden Sie das 8D-PDF direkt aus der Reklamation per E-Mail an den Kunden.",
  "faq_q9": "Wie exportiere ich Daten?",
  "faq_a9": "Die meisten Listen bieten CSV-Export/-Import. Der Report-Builder exportiert nach Excel (XLSX). Scorecards, QBR-Pakete und die Account-Analyse werden aus den jeweiligen Ansichten als PDF exportiert.",
  "faq_q10": "Was bedeuten die Risikostufen der Besuchsnotizen?",
  "faq_a10": "Nachdem Sie eine Notiz diktiert oder hochgeladen haben, stuft die KI sie als Normal (grün), Beobachten (gelb), Risiko (orange) oder Eskalation (rot) ein. Orange benachrichtigt den Kundenbetreuer; Rot alarmiert zusätzlich die Eskalationsempfänger. Sie können die Einstufung mit einer Pflichtbegründung korrigieren.",
  "translations_tab": "Übersetzungen",
  "tr_help": "Überschreiben Sie beliebige Oberflächentexte je Sprache. Ein leerer Wert stellt die Standardübersetzung wieder her. Änderungen gelten sofort für alle Benutzer.",
  "tr_no_overrides": "Noch keine Overrides — suchen Sie oben einen Schlüssel, um einen Text anzupassen.",
  "updated": "Aktualisiert",
  "upload": "Hochladen",
  "ideas_bugs": "Ideen & Bugs",
  "ib_page_desc": "Melden Sie Bugs und Ideen für Encasa, verfolgen Sie deren Status und stimmen Sie ab, um die Roadmap zu gestalten.",
  "ib_report": "Bug / Idee melden",
  "ib_report_title": "Bug oder Idee melden",
  "ib_report_desc": "Helfen Sie uns, Encasa zu verbessern. Beschreiben Sie den Bug oder die Idee und fügen Sie bei Bedarf einen Screenshot hinzu.",
  "ib_type_bug": "Bug",
  "ib_type_idea": "Idee",
  "ib_type_feature_request": "Feature-Wunsch",
  "ib_title_field": "Titel",
  "ib_title_ph": "Kurze, aussagekräftige Zusammenfassung",
  "ib_description": "Beschreibung",
  "ib_description_ph": "Was ist passiert / was wünschen Sie sich? Screenshot direkt hier einfügen.",
  "ib_module_area": "Modul / Bereich",
  "ib_submit": "Absenden",
  "ib_created": "erstellt",
  "ib_fill_required": "Bitte Titel und Beschreibung ausfüllen",
  "ib_screenshot_added": "Screenshot hinzugefügt",
  "ib_dropzone": "Screenshots per Drag & Drop oder Klick anhängen (max. 5)",
  "ib_bugs": "Bugs",
  "ib_ideas_features": "Ideen & Feature-Wünsche",
  "ib_votes": "Stimmen",
  "ib_priority": "Priorität",
  "ib_assigned_to": "Zugewiesen an",
  "ib_submitted_by": "Gemeldet von",
  "ib_details": "Details",
  "ib_manager_only": "Nur Admins und Sales Manager können Status, Priorität und Zuweisung ändern.",
  "ib_move_to_roadmap": "In Roadmap übernehmen",
  "ib_on_roadmap": "In Roadmap",
  "ib_moved_to_roadmap": "In Roadmap übernommen",
  "ib_already_on_roadmap": "Bereits in Roadmap",

  "ib_jump_status": "Status springen / zurücksetzen",
  "ib_linked_release": "Verknüpftes Release",
  "ib_duplicate_of": "Duplikat von",
  "ib_attachments": "Anhänge",
  "ib_max_files": "Maximal 5 Anhänge",
  "ib_dashboard_title": "Ideen & Bugs",
  "ib_open_bugs_severity": "Offene Bugs nach Schweregrad",
  "ib_top_ideas": "Top-bewertete offene Ideen",
  "ib_opened_30d": "Erstellt (30 Tage)",
  "ib_closed_30d": "Geschlossen (30 Tage)",
  "roadmap": "Roadmap",
  "roadmap_desc": "Was wir als Nächstes bauen — stimme ab und beeinflusse die Prioritäten",
  "roadmap_submit": "Idee einreichen",
  "roadmap_submit_desc": "Schlage eine neue Funktion, Verbesserung oder Integration für die Roadmap vor.",
  "roadmap_title_field": "Titel",
  "roadmap_business_value": "Geschäftsnutzen",
  "roadmap_category": "Kategorie",
  "roadmap_type": "Typ",
  "roadmap_priority": "Priorität",
  "roadmap_effort": "Aufwand",
  "roadmap_visibility": "Sichtbarkeit",
  "roadmap_quarter": "Zielquartal",
  "roadmap_kanban": "Board",
  "roadmap_timeline": "Zeitleiste",
  "roadmap_list": "Liste",
  "roadmap_recently_released": "Kürzlich veröffentlicht",
  "roadmap_unscheduled": "Nicht geplant",
  "roadmap_votes_left": "Verbleibende Stimmen diesen Monat",
  "roadmap_voted": "Stimme gespeichert",
  "roadmap_submitted": "Idee eingereicht",
  "roadmap_digest": "Digest (PDF)",
  "roadmap_follow": "Folgen",
  "roadmap_unfollow": "Folge ich",
  "roadmap_reason": "Begründung (öffentlich)",
  "roadmap_reason_ph": "Warum wird dies abgelehnt oder zurückgestellt?",
  "roadmap_reason_required": "Eine schriftliche Begründung ist zum Ablehnen oder Zurückstellen erforderlich",
  "roadmap_release_note": "Release-Note",
  "roadmap_release_version": "Release-Version",
  "roadmap_linked_ideas": "Verknüpfte Ideen & Bugs",
  "roadmap_vote_history": "Abstimmungs-Analyse",
  "roadmap_w_raw": "Stimmen (roh)",
  "roadmap_w_role": "Rollen-gewichtet",
  "roadmap_w_plant": "Werk-gewichtet",
  "roadmap_merge": "Zusammenführen in…",
  "roadmap_merge_desc": "Alle Stimmen und Follower in ein anderes Element verschieben. Dieses Element wird als Duplikat markiert.",
  "roadmap_merge_target": "Zielelement wählen",
  "roadmap_vote_budget": "Monatliches Stimmen-Budget pro Nutzer",
  "roadmap_settings": "Roadmap",
  "roadmap_widget_title": "Roadmap",
  "roadmap_top_voted": "Top-bewertet (noch nicht geplant)",
  "roadmap_my_votes": "Meine Stimmen",
  "roadmap_my_subs": "Meine Einreichungen",
  "nav_group_orders": "Aufträge",
  "orders": "Aufträge",
  "order_inbox": "AI-Auftragseingang",
  "article_master": "Artikelstamm",
  "order_conditions": "Konditionen",
  "open_confirmations": "Offene Bestätigungen",
  "interface_monitor": "Schnittstellen-Monitor",
  "ord_new": "Neuer Auftrag",
  "ord_new_desc": "Kopfdaten erfassen – Positionen anschließend auf der Detailseite.",
  "ord_order_number": "Auftragsnr.",
  "ord_customer": "Kunde",
  "ord_customer_required": "Bitte einen Kunden wählen",
  "ord_po": "PO-Nummer",
  "ord_date": "Auftragsdatum",
  "ord_requested": "Wunschtermin",
  "ord_lines": "Positionen",
  "ord_total": "Summe",
  "ord_source": "Quelle",
  "ord_erp": "ERP-Nummer",
  "ord_description": "Beschreibung",
  "ord_stats_total": "Aufträge gesamt",
  "ord_stats_open_conf": "Offene Bestätigungen",
  "ord_stats_production": "In Produktion",
  "ord_stats_month": "Diesen Monat",
  "ord_excel_export": "Excel-Export",
  "ord_excel_import": "Excel-Import",
  "ord_excel_template": "Import-Vorlage",
  "ord_import_ok": "Aufträge importiert ✓",
  "ord_page": "Seite",
  "ord_created": "Auftrag angelegt",
  "ord_status_updated": "Status aktualisiert",
  "ord_advance": "Weiter",
  "ord_cancel": "Stornieren",
  "ord_cancel_reason": "Stornogrund",
  "ord_reorder": "Nachbestellen",
  "ord_reorder_of": "Nachbestellung von",
  "ord_from_quote": "Aus Angebot",
  "ord_add_line": "Position hinzufügen",
  "ord_select_article": "Artikel wählen…",
  "ord_condition_applied": "Hinterlegte Kondition angewendet",
  "ord_confirm": "Bestätigen",
  "ord_confirmed": "bestätigt",
  "ord_confirmed_at": "Bestätigt am",
  "ord_no_open": "Keine offenen Bestätigungen 🎉",
  "ord_openconf_desc": "Erfasste Aufträge, die noch auf eine Auftragsbestätigung warten – älteste zuerst.",
  "quote_create_order": "Auftrag erstellen",
  "art_new": "Neuer Artikel",
  "art_name": "Artikelname",
  "art_family": "Produktfamilie",
  "art_material": "Material",
  "art_finishing": "Veredelung",
  "art_size": "Format (mm)",
  "art_colors": "Farben",
  "art_winding": "Wickelrichtung",
  "art_core": "Kern (mm)",
  "art_lpr": "Etiketten/Rolle",
  "art_price": "Preis/1000",
  "art_moq": "Mindestmenge",
  "art_deactivated": "Artikel wird in Aufträgen verwendet – auf Inaktiv gesetzt",
  "winding_outside": "Außenwicklung",
  "winding_inside": "Innenwicklung",
  "cond_new": "Neue Kondition",
  "cond_type": "Typ",
  "cond_type_price": "Sonderpreis",
  "cond_type_discount": "Rabatt",
  "cond_type_payment": "Zahlungsbedingung",
  "cond_type_freight": "Fracht",
  "cond_article": "Artikel",
  "cond_all_articles": "Alle Artikel",
  "cond_value": "Wert",
  "cond_price": "Preis/1000",
  "cond_discount": "Rabatt %",
  "cond_payment": "Zahlungsbedingung",
  "cond_min_qty": "Mindestmenge",
  "cond_valid_from": "Gültig ab",
  "cond_valid_to": "Gültig bis",
  "inbox_phase2_title": "AI-Auftragseingang kommt in Phase 2",
  "inbox_phase2_desc": "Hier werden unstrukturierte Bestellungen (E-Mail, PDF) per KI ausgelesen und als Auftragsvorschlag zur Prüfung vorgelegt. Diese Funktion ist als nächster Ausbauschritt geplant.",
  "oi_page_desc": "Unstrukturierte Bestellungen (E-Mail-Text, PDF, Bild) per KI auslesen — der Auftragsvorschlag wird vor der Übernahme geprüft und bearbeitet.",
  "oi_upload": "Datei hochladen",
  "oi_paste": "E-Mail-Text einfügen",
  "oi_paste_desc": "Bestell-E-Mail oder Freitext einfügen — die KI erkennt Kunde, PO-Nummer, Positionen und Termine.",
  "oi_paste_placeholder": "Sehr geehrte Damen und Herren, hiermit bestellen wir …",
  "oi_analyze": "Mit KI analysieren",
  "oi_analyzed_toast": "Analyse abgeschlossen — bitte Vorschlag prüfen",
  "oi_review": "Auftragsvorschlag prüfen",
  "oi_review_desc": "KI-Vorschlag prüfen und bearbeiten. Der Auftrag wird erst nach Ihrer Bestätigung angelegt.",
  "oi_commit": "Auftrag anlegen",
  "oi_committed_toast": "Auftrag angelegt:",
  "oi_discard": "Verwerfen",
  "oi_discarded_toast": "Eingang verworfen",
  "oi_reanalyze": "Neu analysieren",
  "oi_reanalyzed": "Neu analysiert",
  "oi_confidence": "Konfidenz",
  "oi_no_checks": "Keine Auffälligkeiten — Plausibilitätsprüfung bestanden",
  "oi_source": "Quelltext anzeigen",
  "oi_source_col": "Quelle",
  "oi_suggested_date": "Frühester Termin",
  "oi_promised": "Vorgeschlagener Liefertermin (Lieferzeit-Kalkulation)",
  "oi_unmatched": "Nicht im Artikelstamm",
  "oi_suggestions": "Vorschläge",
  "oi_has_errors": "Es liegen Fehler-Hinweise vor — Übernahme trotzdem möglich, sofern Kunde und Mengen gesetzt sind.",
  "oi_empty": "Noch keine Eingänge. E-Mail-Text einfügen oder eine Datei (PDF, EML, Bild) hochladen — die KI erstellt einen Auftragsvorschlag.",
  "oi_stats_open": "Offen (analysiert)",
  "oi_stats_committed": "Übernommen",
  "oi_stats_discarded": "Verworfen",
  "oi_stats_error": "Fehler",
  "oi_status_new": "Neu",
  "oi_status_analyzed": "Analysiert",
  "oi_status_committed": "Übernommen",
  "oi_status_discarded": "Verworfen",
  "oi_status_error": "Fehler",
  "oi_open_order": "Auftrag öffnen:",
  "oi_error_generic": "Analyse fehlgeschlagen — bitte erneut versuchen.",
  "monitor_phase3_title": "Schnittstellen-Monitor kommt in Phase 3",
  "monitor_phase3_desc": "Hier wird die simulierte ERP-Übertragung (Outbox, Wiederholungen, Fehlerfälle) überwacht. Bis dahin steht der Excel-Import/-Export als EDI-Alternative bereit.",
  "ord_confirmation": "Auftragsbestätigung",
  "ord_ab_pdf": "AB-PDF",
  "ord_send_ab": "AB per E-Mail senden",
  "ord_ab_preview": "PDF-Vorschau",
  "ord_ab_last_sent": "AB zuletzt gesendet an",
  "ord_custom_recipient": "Andere E-Mail-Adresse…",
  "ord_ab_msg": "Sehr geehrte Damen und Herren,\n\nanbei erhalten Sie die Auftragsbestätigung {num}.\n\nMit freundlichen Grüßen\n{user}",
  "acct_orders_recent": "Letzte 50 Aufträge",
  "sample_orders": "Musteraufträge",
  "nav_group_administration": "Administration",
  "view": "Ansehen",
  "enabled": "Aktiv",
  "search": "Suchen",
  "first_name": "Vorname",
  "last_name": "Nachname",
  "address": "Adresse",
  "see_margins": "Margen sichtbar",
  "require_mfa": "MFA verpflichtend",
  "my_profile": "Mein Profil",
  "iam_dashboard": "Administrations-\u00dcbersicht",
  "iam_dashboard_sub": "Benutzer, Rollen, Werke und Sicherheit an einem Ort",
  "iam_users": "Benutzer",
  "iam_roles": "Rollen & Rechte",
  "iam_org": "Organisation & Werke",
  "iam_auth": "Anmeldung & Sicherheit",
  "iam_audit": "\u00c4nderungsprotokoll",
  "iam_total_users": "Benutzer insgesamt",
  "iam_active_30d": "Aktiv (30 Tage)",
  "iam_pending_invites": "Offene Einladungen",
  "iam_pending_scope": "Scope-Zuweisung offen",
  "iam_pending_scope_badge": "Scope offen",
  "iam_failed_logins": "Fehlanmeldungen (7 Tage)",
  "iam_reassign_open": "\u00dcbergaben offen",
  "iam_plants": "Werke",
  "iam_roles_count": "Rollen",
  "iam_sso_users": "SSO-Benutzer",
  "iam_invite_user": "Benutzer einladen",
  "iam_invite_single": "Einzeln",
  "iam_bulk_invite": "CSV-Massenimport",
  "iam_invite_help": "Erst Rolle und Scope festlegen, dann Einladung versenden (7 Tage g\u00fcltig).",
  "iam_bulk_help": "Spalten: email;first_name;last_name;role;plants;segments \u2013 Werke als Werkscode (z. B. HAM;KAS).",
  "iam_csv_template": "Vorlage",
  "iam_validate": "Pr\u00fcfen",
  "iam_import_invite": "Importieren & einladen",
  "iam_send_invite": "Einladung senden",
  "iam_invite_sent": "Einladung versendet",
  "iam_search_users": "Name, E-Mail, Abteilung \u2026",
  "iam_save_view": "Ansicht speichern",
  "iam_rename_view": "Ansicht umbenennen",
  "iam_delete_view_confirm": "Diese gespeicherte Ansicht wirklich löschen?",
  "iam_view_exists": "Eine Ansicht mit diesem Namen existiert bereits",
  "iam_view_update": "Mit aktuellen Filtern überschreiben",
  "iam_view_updated": "Ansicht aktualisiert",
  "iam_export_csv": "CSV-Export",
  "iam_selected": "ausgew\u00e4hlt",
  "iam_assign_plants": "Werke zuweisen",
  "iam_assign_segments": "Segmente zuweisen",
  "iam_change_role": "Rolle \u00e4ndern",
  "iam_suspend": "Sperren",
  "iam_reactivate": "Entsperren",
  "iam_deactivate": "Deaktivieren",
  "iam_resend_invite": "Einladung erneut senden",
  "iam_status_active": "Aktiv",
  "iam_status_invited": "Eingeladen",
  "iam_status_suspended": "Gesperrt",
  "iam_status_deactivated": "Deaktiviert",
  "iam_status_inactive": "Inaktiv",
  "iam_last_login": "Letzter Login",
  "iam_auth_method": "Anmeldung",
  "iam_no_users": "Keine Benutzer gefunden",
  "iam_bulk_dialog_help": "Die Auswahl wird auf alle markierten Benutzer angewendet.",
  "iam_tab_profile": "Profil",
  "iam_tab_permissions": "Rolle & Rechte",
  "iam_tab_scope": "Scope",
  "iam_tab_activity": "Aktivit\u00e4t",
  "iam_tab_sessions": "Sitzungen",
  "iam_resolved_perms": "Aufgel\u00f6ste Rechte \u2013 dieser Benutzer darf:",
  "iam_effective_plants": "Effektive Werke",
  "iam_account_count": "Sichtbare Kunden",
  "iam_revoke": "Beenden",
  "iam_sessions_none": "Keine Sitzungen",
  "iam_activity_none": "Keine Aktivit\u00e4t",
  "iam_owned_accounts": "Eigene Kunden",
  "iam_successor_required": "Nachfolger erforderlich",
  "iam_choose_successor": "Nachfolger w\u00e4hlen",
  "iam_gdpr_export": "DSGVO-Export",
  "iam_anonymize": "Anonymisieren",
  "iam_disable_mfa": "MFA zur\u00fccksetzen",
  "iam_mfa_enabled": "MFA aktiv",
  "iam_job_title": "Position",
  "iam_department": "Abteilung",
  "iam_manager": "Berichtet an",
  "iam_phone": "Telefon",
  "iam_language": "Sprache",
  "iam_compliance_help": "DSGVO: Datenexport auf Anfrage, Anonymisierung nach Ablauf der Aufbewahrungsfrist.",
  "iam_clone_role": "Rolle klonen",
  "iam_new_role": "Neue Rolle",
  "iam_system_role": "System-Rolle",
  "iam_affected_users": "betroffene Benutzer",
  "iam_matrix": "Rechtematrix",
  "iam_matrix_help": "Module als Zeilen, Aktionen als Spalten. Sensible Rechte sind markiert.",
  "iam_clone_help": "System-Rollen sind unver\u00e4nderlich \u2013 klonen und die Kopie anpassen.",
  "iam_unassigned_view": "Nicht zugeordnete Kunden",
  "iam_sensitive_confirm": "Dieses Recht ist sensibel. Wirklich vergeben?",
  "iam_sensitive_title": "Sensibles Recht",
  "iam_grant": "Vergeben",
  "iam_role_saved": "Rolle gespeichert",
  "iam_role_immutable": "System-Rollen sind unver\u00e4nderlich (nur Ansicht).",
  "iam_description": "Beschreibung",
  "iam_roles_sub": "System-Rollen, Custom-Rollen und Rechtematrix",
  "act_view": "Ansehen",
  "act_create": "Anlegen",
  "act_edit": "Bearbeiten",
  "act_delete": "L\u00f6schen",
  "act_approve": "Freigeben",
  "act_export": "Export",
  "act_configure": "Konfigurieren",
  "iam_organization": "Organisation",
  "iam_legal_entities": "Rechtseinheiten",
  "iam_regions": "Regionen",
  "iam_plant_code": "Werkscode",
  "iam_country": "Land",
  "iam_city": "Stadt",
  "iam_timezone": "Zeitzone",
  "iam_plant_manager": "Werksleiter",
  "iam_vat_id": "USt-IdNr.",
  "iam_default_language": "Standardsprache",
  "iam_default_currency": "Standardw\u00e4hrung",
  "iam_org_sub": "Rechtseinheiten, Regionen und Werke (50+ Standorte)",
  "iam_plant_help": "Werkscode ist eindeutig und wird f\u00fcr Scope-Zuweisungen und CSV-Import genutzt.",
  "iam_search_plants": "Werk suchen (Code, Name, Stadt)",
  "iam_idps": "Identity Provider",
  "iam_add_idp": "IdP hinzuf\u00fcgen",
  "iam_idp_type": "Typ",
  "iam_domains": "E-Mail-Domains",
  "iam_enforce_sso": "SSO Pflicht",
  "iam_jit": "Just-in-Time-Provisioning",
  "iam_jit_role": "Standardrolle bei JIT",
  "iam_group_mappings": "Gruppen-Mapping (IdP-Gruppe \u2192 Rolle)",
  "iam_no_idps": "Noch kein Identity Provider konfiguriert",
  "iam_idp_help": "Mehrere IdPs k\u00f6nnen parallel aktiv sein. Die Domain entscheidet, wohin ein Login geroutet wird.",
  "iam_enforce_warning": "Bei aktiver SSO-Pflicht werden bestehende Passw\u00f6rter dieser Domains deaktiviert.",
  "iam_security": "Sicherheit",
  "iam_pw_min": "Passwort-Mindestl\u00e4nge",
  "iam_breach_check": "Abgleich mit Datenlecks",
  "iam_idle_timeout": "Inaktivit\u00e4t (Minuten)",
  "iam_session_lifetime": "Sitzungsdauer (Stunden)",
  "iam_concurrent_sessions": "Parallele Sitzungen",
  "iam_remember_days": "Angemeldet bleiben (Tage)",
  "iam_mfa_roles": "MFA-Pflicht f\u00fcr Rollen",
  "iam_invite_days": "Einladung g\u00fcltig (Tage)",
  "iam_login_audit": "Anmelde-Protokoll",
  "iam_scim_enable": "SCIM 2.0 aktivieren",
  "iam_scim_token": "SCIM-Token",
  "iam_rotate_token": "Token erneuern",
  "iam_scim_help": "Im IdP als SCIM-Endpunkt eintragen. Deaktivierte Benutzer landen automatisch in der \u00dcbergabe-Warteschlange.",
  "iam_auth_sub": "Identity Provider, Passwortregeln, MFA, SCIM und Anmelde-Protokoll",
  "iam_audit_sub": "Unver\u00e4nderliches Protokoll aller Rechte- und Benutzer\u00e4nderungen",
  "iam_audit_filter_actor": "Akteur",
  "iam_audit_event": "Ereignis",
  "iam_audit_before": "Vorher",
  "iam_audit_after": "Nachher",
  "iam_audit_export": "Protokoll exportieren",
  "iam_all_plants": "Alle Werke",
  "iam_all_segments": "Alle Segmente",
  "iam_segments": "Segmente",
  "iam_select_region": "Region",
  "iam_effective": "Effektiv",
  "iam_reassign": "Kunden umverteilen",
  "iam_reassign_preview": "Vorschau",
  "iam_reassign_help": "Kunden nach Segment, Werk oder aktuellem Verantwortlichen filtern und in einem Schritt \u00fcbergeben.",
  "iam_new_owner": "Neuer Verantwortlicher",
  "iam_current_owner": "Aktueller Verantwortlicher",
  "iam_affected_accounts": "betroffene Kunden",
  "iam_open_quotes": "offene Angebote",
  "iam_open_opps": "offene Opportunities",
  "iam_execute": "Ausf\u00fchren",
  "iam_notify_owners": "Benachrichtigen",
  "login_continue": "Weiter",
  "login_back": "Zur\u00fcck",
  "login_forgot": "Passwort vergessen?",
  "login_reset_sent": "Falls das Konto existiert, wurde eine E-Mail versendet.",
  "login_mfa_title": "Bitte den 6-stelligen Code aus Ihrer Authenticator-App eingeben.",
  "login_mfa_code": "MFA-Code",
  "login_verify": "Best\u00e4tigen",
  "login_mfa_setup_hint": "F\u00fcr Ihre Rolle ist MFA vorgeschrieben \u2013 bitte unter \u201eMein Profil\u201c einrichten.",
  "login_invite_welcome": "Willkommen! Bitte legen Sie Ihr Passwort fest.",
  "login_set_password": "Neues Passwort festlegen",
  "login_pw_save": "Passwort speichern",
  "login_pw_set": "Passwort gespeichert. Bitte anmelden.",
  "login_pw_rules": "Mindestens 12 Zeichen, Buchstaben und Zahlen, kein bekanntes Leak-Passwort.",
  "prof_change_password": "Passwort \u00e4ndern",
  "prof_current_pw": "Aktuelles Passwort",
  "prof_new_pw": "Neues Passwort",
  "prof_confirm_pw": "Passwort wiederholen",
  "prof_pw_mismatch": "Die Passw\u00f6rter stimmen nicht \u00fcberein",
  "prof_saved": "Profil gespeichert",
  "prof_mfa_setup": "Zwei-Faktor-Authentifizierung",
  "prof_mfa_scan": "Secret in der Authenticator-App hinterlegen und Code eingeben:",
  "prof_mfa_activate": "Aktivieren",
  "prof_sessions": "Meine Sitzungen",
  "admin_moved_users": "Die Benutzerverwaltung ist in das neue Modul \u201eAdministration\u201c umgezogen: Directory mit serverseitiger Suche, Einladungen, Scope-Zuweisung, Sitzungen und Audit-Log.",
  "admin_moved_roles": "Rechteprofile wurden zu Rollen migriert. Rollen, Rechtematrix und Custom-Rollen werden jetzt unter \u201eRollen & Rechte\u201c verwaltet.",
  "primary_segment": "Segment (prim\u00e4r)",
  "owning_plants": "Betreuende Werke",
  "primary_plant": "Hauptwerk",
  "account_team": "Account-Team",
  "guide_manual": "Handbuch",
  "guide_search_ph": "Funktion suchen…",
  "guide_update_btn": "Handbuch aktualisieren",
  "guide_updating": "Wird aktualisiert…",
  "guide_last_updated": "Zuletzt aktualisiert",
  "guide_up_to_date": "Aktuell",
  "guide_generating": "Das Handbuch wird gerade erstellt – die Inhalte verbessern sich in Kürze.",
  "guide_sec_purpose": "Wozu?",
  "guide_sec_steps": "Schritt für Schritt",
  "guide_sec_tips": "Tipps",
  "guide_sec_roles": "Rollen & Rechte",
  "guide_select_prompt": "Wählen Sie links ein Thema, um die Anleitung zu lesen.",
  "guide_no_results": "Keine passende Funktion gefunden.",
  "guide_ai_badge": "KI-erstellt",
  "guide_all_topics": "Alle Themen",
  "guide_whats_new": "Was ist neu",
  "guide_new_badge": "Neu",
  "guide_whats_new_empty": "Noch keine Neuigkeiten.",
};
export default dict;
